export enum SubAccountType {
  taxBucket = 1,
  emergencyBucket,
  emergencySavings,
}

export enum CategorizationTypes {
  expense = 'EXPENSE',
  income = 'INCOME',
}
